import { isVimOsAppMode } from '../../../vim-os-sdk-migration';
import { useRuntimeNotifications } from './useRuntimeNotifications';
import { useSdkNotifications } from './useSdkNotifications';

export const useNotification = isVimOsAppMode ? useSdkNotifications : useRuntimeNotifications;
